import { render, staticRenderFns } from "./PaymentDetailList.vue?vue&type=template&id=406640f4&scoped=true&lang=pug"
import script from "./PaymentDetailList.vue?vue&type=script&lang=js"
export * from "./PaymentDetailList.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailList.vue?vue&type=style&index=0&id=406640f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406640f4",
  null
  
)

export default component.exports